import { render, staticRenderFns } from "./MainCompanyPicker.vue?vue&type=template&id=4a889b4a&scoped=true&"
import script from "./MainCompanyPicker.vue?vue&type=script&lang=js&"
export * from "./MainCompanyPicker.vue?vue&type=script&lang=js&"
import style0 from "./MainCompanyPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a889b4a",
  null
  
)

export default component.exports